module.exports = __webpack_public_path__ + "img/minus.984d48a8.svg";